module.exports = __webpack_public_path__ + "img/plb11.1464b3f5.png";